<template>
  <el-drawer
    title="高级筛选"
    width="400"
    direction="rtl"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="isShow=false"
    :modal-append-to-body="false"
    :wrapperClosable="false"
    :append-to-body="true"
    :z-index="9001"
  >
    <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
      <el-row>
        <el-col :span='24'>
          <el-form-item label="状态">
            <el-select v-model.trim="JZForm.enableFlag" :popper-append-to-body="false" placeholder="请选择状态">
              <el-option :label="op.label" :value="op.value" v-for="op in statusList" :key="op.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='24'>
          <el-form-item label="品牌名称">
            <el-input placeholder="请输入品牌名称" v-model.trim="JZForm.name" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span='24'>
          <el-form-item label="品牌简称">
            <el-input placeholder="请输入品牌简称" v-model.trim="JZForm.shortName" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: right; position:absolute; bottom:20px;right:20px;">
      <el-button @click="handleReset">清空</el-button>
      <el-button type="primary" @click="handleConfirm" >查询</el-button>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: '',
  methods: {
    initPage () {
      this.isShow = true;
    },
    // 重置条件处理
    handleReset () {
      this.JZForm = this.$options.data().JZForm;
    },
    handleConfirm () {
      this.$emit('updatePageData', this.JZForm);
      this.isShow = false;
    },
  },
  data () {
    return {
      JZForm: {
        name: '',
        shortName: '',
        enableFlag: true,
        nameOrShortName: '',
      },
      isShow: false,
      statusList: [
        { label: '全部', value: '', num: 0 },
        { label: '已启用', value: true, num: 0 },
        { label: '已禁用', value: false, num: 0 },
      ],
    };
  },
};
</script>
<style scoped lang='scss'>
</style>
